import { Component, OnInit } from '@angular/core';
import { BillPayHistory, Data, Service } from '../mock-data/mock-data';

@Component({
  selector: 'app-history-container',
  templateUrl: './history-container.component.html',
  styleUrls: ['./history-container.component.css'],
  providers: [Service]
})
export class HistoryContainerComponent implements OnInit {
  billPayHistory: BillPayHistory[];
  chartdDataSource: Data[];
  constructor(private service: Service) {
    this.billPayHistory = service.getBillPayHistory();
    this.chartdDataSource = service.getData();
  }

  customizeTooltip(arg: any) {
    return {
      text: "$" + arg.point._dataItem.data.amount + '\n' + arg.valueText + " gal"
    };
  }

  completedValue(rowData) {
    return rowData.Status == "Completed";
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/history-container/history-container.component.ts